module.exports = __webpack_public_path__ + "static/media/feedback-new-home.491377e9.svg";